export default __webpack_public_path__ + "static/media/vehicle_back_right.3a5d9414.svg";